<template>
  <div class="page flex-v">
    <HeaderNav actId="3" />
    <div class="container flex">
      <Sider :type="2"></Sider>
      <div class="layout-right">
        <ScrollBar ref="scrollbar" class="scrollbar">
          <div class="detail-info" :style="getMinHeightStyle" v-html="txt">
          </div>
        </ScrollBar>
      </div>
    </div>
  </div>
</template>
<script>
import {
  mapGetters,
  mapActions
} from 'vuex';

export default {
  data() {
    return {
      txt: '',
      loaded: 0
    }
  },
  computed: {
    ...mapGetters([
      'getClientHeight'
    ]),
    getMinHeightStyle() {
      return {
        minHeight: `${this.getClientHeight-140}px`
      }
    }
  },
  created() {
    this.getInfo();
  },
  methods: {
    async getInfo() {
      this.loaded = 0;
      const res = await this.$post('/staticpage/info.json', {
        kind: 2
      });
      if (res.status == 200) {
        let data = res.data || {};
        this.txt = data.contents;
      }
      this.loaded = 1;
    }
  }
}
</script>
<style lang="less" scoped>
.detail-info {
  width: 900px;
  margin: 20px auto;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  box-sizing: border-box;
  padding: 20px;
  font-size: 14px;
  line-height: 34px;
  color: #666;
  min-height: 500px;
  /deep/ img {
    max-width: 100%;
    display: block;
    margin: 0 auto
  }
  /deep/ p {
    margin-bottom: 20px;
    text-align: justify;
    text-indent: 30px;
  }
}
</style>